// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cellBody___4NXzf{text-align:left}div[class^=GroupByHeader__groupByContainer].groupBy___U6rZl{margin-top:8px;border-top:0;padding-left:32px}\n", "",{"version":3,"sources":["webpack://./src/components/GlobalRulesTable/EmptyRuleGroups/GroupCell.css"],"names":[],"mappings":"AAAA,kBACI,eAAA,CAGJ,4DACQ,cAAA,CACA,YAAA,CACA,iBAAA","sourcesContent":[".cellBody {\n    text-align: left;\n}\n\ndiv[class^='GroupByHeader__groupByContainer'].groupBy {\n        margin-top: 8px;\n        border-top: 0;\n        padding-left: 32px;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cellBody": "cellBody___4NXzf",
	"groupBy": "groupBy___U6rZl"
};
export default ___CSS_LOADER_EXPORT___;
